import styles from "./Download.module.scss";
import { Link } from "react-router-dom";

export const Download = () => {
    return (
        <div className={styles.Download}>
            <div className={styles.title}>
                <span>Download</span> your life-changing Health Guide
                <br /> (ENGLISH)
            </div>
            <div className={styles.context}>
                <div className={styles.text}>
                    Dr. Torsunov’s health guide is designed for individuals who
                    are eager to explore innovative approaches to enhance their
                    physical and spiritual well-being. In this guide, we will
                    consider the primary root causes of all problems related not
                    only to health, but to human life in general. We will talk
                    about the main reasons for aging & diseases, as well as the
                    five energy layers and their relationships with bodily
                    functions. We will then discuss effective methods of healing
                    the body and mind which will, as a result, improve your
                    quality of life and relationships with people.
                </div>
                <div className={styles.buttonWrapper}>
                    <div>
                        <div className={styles.label}>TEXT VERSION, PDF</div>
                        <button className={styles.buttonColored}>
                            <Link
                                to={
                                    "https://www.fatfreecartpro.com/i/12xug?card"
                                }
                                target="_blank"
                            >
                                PAY $9.90
                            </Link>
                        </button>
                    </div>
                    <div>
                        <div className={styles.label}>AUDIO VERSION, MP3</div>
                        <button className={styles.buttonBordered}>
                            <Link
                                to={
                                    "https://www.fatfreecartpro.com/i/14fs4?card"
                                }
                                target="_blank"
                            >
                                PAY $9.90
                            </Link>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
